/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZGlzYWJpbGl0eS9jb21wb25lbnRzL2NhbmRpZGF0ZS1kaXNhYmlsaXRpZXMtYWRtaW4vY2FuZGlkYXRlLWRpc2FiaWxpdGllcy1hZG1pbi9uZXctY2FuZGlkYXRlLWRpc2FiaWxpdGllcy1hZG1pbi9uZXctY2FuZGlkYXRlLWRpc2FiaWxpdGllcy1hZG1pbi5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvbW9kdWxlcy9kaXNhYmlsaXR5L2NvbXBvbmVudHMvY2FuZGlkYXRlLWRpc2FiaWxpdGllcy1hZG1pbi9jYW5kaWRhdGUtZGlzYWJpbGl0aWVzLWFkbWluL25ldy1jYW5kaWRhdGUtZGlzYWJpbGl0aWVzLWFkbWluL25ldy1jYW5kaWRhdGUtZGlzYWJpbGl0aWVzLWFkbWluLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/disability/components/candidate-disabilities-admin/candidate-disabilities-admin/new-candidate-disabilities-admin/new-candidate-disabilities-admin.component.scss.shim.ngstyle.ts